import { gql } from "@apollo/client";

export const GET_ALL_VIDEO = gql`
  query allVideo($limit: Int, $sort: String) {
    citizenJoyVideos(limit: $limit, sort: $sort) {
      title
      video_url
      created_date
    }

    concertVideos(limit: $limit, sort: $sort) {
      title
      url
      created_date
    }

    laborIssueVideos(limit: $limit, sort: $sort) {
      title
      video_url
      created_date
    }
  }
`;
